class BranchManagementAverageDailyVaultBalanceController {
  /*@ngInject*/
    constructor() {}
  $onInit() {}
}
export default BranchManagementAverageDailyVaultBalanceController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/average-daily-vault-balance/average_daily_vault_balance.controller.js